import { render, staticRenderFns } from "./storeTongueQrCode.vue?vue&type=template&id=0ff25c38&scoped=true"
import script from "./storeTongueQrCode.vue?vue&type=script&lang=ts"
export * from "./storeTongueQrCode.vue?vue&type=script&lang=ts"
import style0 from "./storeTongueQrCode.vue?vue&type=style&index=0&id=0ff25c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff25c38",
  null
  
)

export default component.exports